import { useSnapshot } from "valtio";

import React from "react";

import { CommandInsertionProblemModalWrapper } from "@components/common/CommandInsertionProblemModalWrapper";

import { kioskStore } from "@pages/Kiosk/store";

export function ContainerContent(): JSX.Element {
    const { commandInsertionProblemModalOpened } = useSnapshot(kioskStore);

    return (
        <React.Fragment>
            {commandInsertionProblemModalOpened.isInsertError ||
            commandInsertionProblemModalOpened.isGodiaError ? (
                <CommandInsertionProblemModalWrapper />
            ) : null}
        </React.Fragment>
    );
}
